// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles de l'attestation "documents administratifs a jour".
 * Palette fermee du design system : texte principal #374151, accent orange #f97316.
 */

.attestation-documents {
  /* Espace au-dessus des boutons d'action de l'onglet Offre, ou l'attestation se place. */
  margin: 1.6rem 0;
}

.attestation-documents-row {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
}

.attestation-documents-checkbox {
  /* Aligne visuellement la case avec la premiere ligne de texte. */
  margin-top: 0.2rem;
  width: 1.6rem;
  height: 1.6rem;
  flex-shrink: 0;
  cursor: pointer;
  /* Teinte la case a l'orange du design system quand elle est cochee. */
  accent-color: #f97316;
}

.attestation-documents-checkbox:disabled {
  cursor: not-allowed;
}

/* Etat d'erreur : la case est mise en evidence quand l'obligation n'est pas remplie. */
.attestation-documents-checkbox.error {
  outline: 2px solid #dc2626;
  outline-offset: 1px;
  border-radius: 2px;
}

.attestation-documents-label {
  font-size: 1.4rem;
  line-height: 1.5;
  color: #374151;
  cursor: pointer;
}

/* Lien orange souligne : ouvre la modale de profil sur l'onglet Documents (pas de navigation). */
.attestation-documents-link {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: #f97316;
  text-decoration: underline;
  cursor: pointer;
}

.attestation-documents-link:hover {
  /* Legere accentuation au survol, sans sortir de la palette. */
  color: #ea660c;
}

.attestation-documents-link:disabled {
  cursor: not-allowed;
}

/* L'erreur reutilise la classe globale 'error-message' ; on ajuste juste l'espacement local. */
.attestation-documents-error {
  display: block;
  margin-top: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/composants/AttestationDocuments/AttestationDocuments.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,wFAAwF;EACxF,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,cAAc;EACd,eAAe;EACf,sEAAsE;EACtE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uFAAuF;AACvF;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,iGAAiG;AACjG;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,8DAA8D;EAC9D,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+FAA+F;AAC/F;EACE,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/**\n * Styles de l'attestation \"documents administratifs a jour\".\n * Palette fermee du design system : texte principal #374151, accent orange #f97316.\n */\n\n.attestation-documents {\n  /* Espace au-dessus des boutons d'action de l'onglet Offre, ou l'attestation se place. */\n  margin: 1.6rem 0;\n}\n\n.attestation-documents-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.8rem;\n}\n\n.attestation-documents-checkbox {\n  /* Aligne visuellement la case avec la premiere ligne de texte. */\n  margin-top: 0.2rem;\n  width: 1.6rem;\n  height: 1.6rem;\n  flex-shrink: 0;\n  cursor: pointer;\n  /* Teinte la case a l'orange du design system quand elle est cochee. */\n  accent-color: #f97316;\n}\n\n.attestation-documents-checkbox:disabled {\n  cursor: not-allowed;\n}\n\n/* Etat d'erreur : la case est mise en evidence quand l'obligation n'est pas remplie. */\n.attestation-documents-checkbox.error {\n  outline: 2px solid #dc2626;\n  outline-offset: 1px;\n  border-radius: 2px;\n}\n\n.attestation-documents-label {\n  font-size: 1.4rem;\n  line-height: 1.5;\n  color: #374151;\n  cursor: pointer;\n}\n\n/* Lien orange souligne : ouvre la modale de profil sur l'onglet Documents (pas de navigation). */\n.attestation-documents-link {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  color: #f97316;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.attestation-documents-link:hover {\n  /* Legere accentuation au survol, sans sortir de la palette. */\n  color: #ea660c;\n}\n\n.attestation-documents-link:disabled {\n  cursor: not-allowed;\n}\n\n/* L'erreur reutilise la classe globale 'error-message' ; on ajuste juste l'espacement local. */\n.attestation-documents-error {\n  display: block;\n  margin-top: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
